import { render } from "./Events.vue?vue&type=template&id=1bf40ba5&bindings={\"event\":\"data\"}"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script